import { Chip } from "@mui/joy";
import { useTranslation } from "../../../../i18n";
import { useMemo } from "react";

const statusStylesMap: Record<
  string,
  { backgroundColor: string; color: string }
> = {
  DRAFT: { backgroundColor: "#bdbdbd", color: "#000" }, // Grey
  PENDING: { backgroundColor: "#ffb74d", color: "#000" }, // Light orange
  CONFIRMED: { backgroundColor: "#0d47a1", color: "#fff" }, // Dark blue
  CANCELLED: { backgroundColor: "#d32f2f", color: "#fff" }, // Red
  INPROGRESS: { backgroundColor: "#42a5f5", color: "#000" }, // Light blue
  COMPLETED: { backgroundColor: "#388e3c", color: "#fff" }, // Green
};

export function renderIcon(status: string) {
  const chipStyles = statusStylesMap[status] || {
    backgroundColor: "#e0e0e0",
    color: "#000",
  };
  return (
    <Chip size={"sm"} sx={{ ...chipStyles, borderRadius: 4 }}>
      {status}
    </Chip>
  );
}

export function useStatusOptions() {
  const t = useTranslation();
  const statusOptions = useMemo(
    () => [
      {
        label: t("Draft"),
        value: "DRAFT",
      },
      {
        label: t("Pending"),
        value: "PENDING",
      },
      {
        label: t("Confirmed"),
        value: "CONFIRMED",
      },
      {
        label: t("Cancelled"),
        value: "CANCELLED",
      },
      {
        label: t("In-Progress"),
        value: "INPROGRESS",
      },
      {
        label: t("Completed"),
        value: "COMPLETED",
      },
    ],
    [t]
  );
  return statusOptions;
}
